{
  "hero": {
    "tag": "Curiosity starts here",
    "titlePrefix": "Curious",
    "titleHighlight": "Minds",
    "subtitle": "Friendly, clear explanations that spark questions and joy.",
    "description": "Join thousands of curious kids learning something new every day.",
    "primaryCta": "Start exploring",
    "secondaryCtaLoggedIn": "Set up family plan",
    "secondaryCtaLoggedOut": "Create parent account",
    "photoAlt": "Hero photo {index}"
  },
  "filter": {
    "title": "Find Your Answer"
  },
  "empty": {
    "title": "No questions found",
    "subtitle": "Try adjusting your filters or search terms"
  }
}
